export { SettingsPage } from './SettingsPage'
export type {
  SettingsPageFooterProps,
  SettingsPageProps,
} from './SettingsPage.types'
